import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: "history",
	pageRouting: true,
	base: process.env.BASE_URL,
	scrollBehavior(e) {
		/*console.log(e)
		if ( e.query.scrollTop === undefined || e.query.scrollTop === true ) {
			document.querySelector('#app').scrollIntoView({ behavior: 'smooth' });
		}*/
	},
	routes: [
		{
			name: 'index',
			path: '/',
			components: {
				'rv-app': () => import('@/cs1/pages/cs1Main')
			},
		},


		/**
		 * 게시판
		 */
		{
			name: 'appBoards',
			path: '/app/board/:boardKey?/',
			components: {
				'rv-app': () => import('@/cs1/components/boards/appBoards')
				//'rv-app': () => import('@/cs1/components/boards/appBoards.vue')
			},
		},


		/**
		 * 게시판 통합 검색
		 */
		{
			name: 'appSearchers',
			path: '/app/searcher/:searchText',
			components: {
				'rv-app': () => import('@/cs1/components/searchers/appSearchers')
			},
		},
		


		/**
		 * 교육
		 */
		{
			// 교육 목록 + 상세
			name: 'appEducations',
			path: '/app/education/main/:cateCode?/',
			components: {
				'rv-app': () => import('@/cs1/components/educations/appEducations')
			},
		},
		{
			// 학습현황 + 관심교육
			name: 'appMyEducations',
			path: '/app/education/mine/:WISH_LIKE?',
			components: {
				'rv-app': () => import('@/cs1/components/educations/appMyEducations')
			},
		},
		{
			// 교육 진행
			name: 'eduProceed',
			path: '/app/education/proceed/:emIdx/:userIdEnc/',
			components: {
				'rv-app': () => import('@/cs1/components/educations/answer/eduProceed')
			},
		},
		{
			// 교육 과정
			name: 'appEduCourse',
			path: '/app/education/course/:cateCode?/',
			components: {
				'rv-app': () => import('@/cs1/components/educations/appEduCourses')
			},
		},


		
		/**
		 * 로그인 + 회원가입
		 */
		{
			name: 'login',
			path: '/member/login',
			components: {
				'rv-app': () => import('@/cs1/components/member/login')
			},
		},
		
		
		// 회원 가입 Start
		{
			// join start
			name: 'joinStart',
			path: '/member/joinStart/',
			components: {
				'rv-app': () => import('@/cs1/components/member/join/joinStart')
			}
		},
		{
			// join form
			name: 'joinForm',
			path: '/member/joinForm/',
			components: {
				'rv-app': () => import('@/cs1/components/member/join/joinForm')
			}
		},
		{
			// join done
			name: 'joinAuth',
			path: '/member/joinAuth/',
			components: {
				'rv-app': () => import('@/cs1/components/member/join/joinAuth')
			}
		},
		{
			// join done
			name: 'joinDone',
			path: '/member/joinDone/',
			components: {
				'rv-app': () => import('@/cs1/components/member/join/joinDone')
			}
		},
		// 회원 가입 End
		
		
		// SNS Login Return Start
		{
			// KAKAO 로그인 리턴 주소
			name: 'kakaoReturn',
			path: '/member/sns/kakaoReturn',
			components: {
				'rv-app': () => import('@/cs1/components/member/sns/kakaoReturn')
			}
		},
		{
			// KAKAO IOS 로그인 리턴 주소
			name: 'kakaoIOSReturn',
			path: '/member/sns/kakaoIOSReturn',
			components: {
				'rv-app': () => import('@/cs1/components/member/sns/kakaoIOSReturn')
			}
		},
		{
			// NAVER 로그인 리턴 주소
			name: 'naverReturn',
			path: '/member/sns/naverReturn',
			components: {
				'rv-app': () => import('@/cs1/components/member/sns/naverReturn')
			}
		},
		{
			// NAVER IOS 로그인 리턴 주소
			name: 'naverIOSReturn',
			path: '/member/sns/naverIOSReturn',
			components: {
				'rv-app': () => import('@/cs1/components/member/sns/naverIOSReturn')
			}
		},
		// SNS Login Return End
		
		
		// Find Account Start
		{
			// 아이디 찾기
			name: 'findId',
			path: '/find/findId',
			components: {
				'rv-app': () => import('@/cs1/components/member/find/findId')
			}
		},
		{
			// 비밀번호 찾기
			name: 'findPasswd',
			path: '/find/findPasswd',
			components: {
				'rv-app': () => import('@/cs1/components/member/find/findPasswd')
			}
		},

		{
			/**
			 * 정적페이지 표출
			 * 관리자 > 페이지 관리
			 */
			name: 'staticsPage',
			path: '/app/statics/:PAGE_CODE',
			components: {
				'rv-app': () => import('@/cs1/components/statics/appPage')
			}

		},
		

		/**
		 * 마이페이지
		 */

		{
			// 마이페이지 인덱스
			name: 'mypage',
			path: '/mypage/',
			components: {
				'rv-app': () => import('@/cs1/components/mypage/index')
			}

		},

		{
			// 회원정보 수정
			name: 'infoForm',
			path: '/mypage/infoForm',
			components: {
				'rv-app': () => import('@/cs1/components/mypage/infoForm')
}
		},
		{
			// 비밀번호 변경
			name: 'changePassword',
			path: '/mypage/changePassword',
			components: {
				'rv-app': () => import('@/cs1/components/mypage/changePassword')
			}
		},
		{
			name: 'popupOpen',
			path: '/popup/:idx',
			components: {
				'rv-app': () => import('@/components/display/popupOpen')
			},

		}



	],
});
